import { focusHelper, removeFocusHelper } from "../helpers/focus-helper.js";

class IonCollapsibleLinks extends HTMLElement {
    constructor() {
        super();

        this.control = this.querySelector("button.collapsible-trigger");
        this.panel = this.querySelector(".collapsible-panel");

        this.onHoverHandler = this.onHover.bind(this);
        this.onLeaveHandler = this.onLeave.bind(this);
        this.onToggleHandler = this.onToggle.bind(this);
        this.onKeyUpHanlder = this.onKeyUp.bind(this);

        this.bindEvents();
    }

    attributeChangedCallback(name, oldState, newState) {
        if (oldState === "false" && newState === "true") {
            this.control.setAttribute("aria-expanded", "true");
        }

        if (oldState === "true" && newState === "false") {
            this.control.setAttribute("aria-expanded", "false");
        }
    }

    static get observedAttributes() {
        return ["open"];
    }

    get isClosed() {
        return this.getAttribute("open") === "false";
    }

    bindEvents() {
        this.addEventListener("mouseenter", this.onHoverHandler, false);
        this.addEventListener("mouseleave", this.onLeaveHandler, false);
        this.control.addEventListener("click", this.onToggleHandler, false);
        document.addEventListener("keyup", this.onKeyUpHanlder);
    }

    onKeyUp(event) {
        if (this.isClosed) return;
        if (event.code.toUpperCase() === "ESCAPE" && !this.isClosed) this.close();
    }

    onToggle(event) {
        if (this.control.getAttribute("aria-expanded") === "false" && this.isClosed) {
            this.open();
        }
    }

    onHover(event) {
        if (this.control.getAttribute("aria-expanded") === "false" && this.isClosed) {
            this.open();
        }
    }

    onLeave(event) {
        if (this.control.getAttribute("aria-expanded") === "true" && !this.isClosed) {
            this.close();
        }
    }

    open() {
        this.setAttribute("open", "true");
        focusHelper(this.panel);
    }

    close() {
        this.setAttribute("open", "false");
        removeFocusHelper(this.control);
    }
}

customElements.define("ion-collapsible-links", IonCollapsibleLinks);
